import React, { memo, useEffect, useMemo, useState } from "react";
import FormLogin from "../SigninLoader/subComponents/FormLogin";
import styles from "./signinLoader.module.scss";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { companySelector } from "../../../app/selectors/company";

// constants
import { VIEWS } from "../../constants";

const DEFAULT_BKD = "/assets/images/background.png";

const SigninLoader = withRouter(({ history, currentView }) => {
  const { company } = useSelector(companySelector);

  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const style = useMemo(
    () => ({
      "--background-url": isImageLoaded
        ? `url(${company?.picture?.login || DEFAULT_BKD})`
        : "",
    }),
    [isImageLoaded, company?.picture?.login]
  );
  
  const containerClass = useMemo(() => {
    return isImageLoaded
      ? `${styles.displayImage} ${styles.imageLoaded}`
      : styles.displayImage;
  }, [isImageLoaded]);

  useEffect(() => {
    const img = new Image();

    img.src = company?.picture?.login || DEFAULT_BKD;

    img.onload = () => setIsImageLoaded(true);
  }, [company?.picture?.login]);

  return (
    <div className={styles.bk}>
      <div style={style} className={containerClass} />
      <div className={styles.form}>
        <FormLogin history={history} />
      </div>
    </div>
  );
});

export default memo(SigninLoader);
